export default __webpack_public_path__ + "static/media/c4c_580x400.9db5e3dc.jpg";